import { useEffect, useState } from "react";
import clickSound from '../Interface/click_Sound.mp3'
import bebasFont from '../../public/bebas-neue-v9-latin-regular.woff';
import '../styles/style.css'

const clickSoundInstance = new Audio(clickSound);
clickSoundInstance.volume = 0.5;

const Modal = ({ isOpen, onClose, title, children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [shouldRender, setShouldRender] = useState(false);

    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                handleClose();
            }
        };

        if (isOpen) {
            setShouldRender(true);
            document.addEventListener('keydown', handleEscape);
            document.body.style.overflow = 'hidden';
            
            // Trigger fade in after render
            const fadeInTimer = setTimeout(() => {
                setIsVisible(true);
            }, 50);

            return () => {
                clearTimeout(fadeInTimer);
                document.removeEventListener('keydown', handleEscape);
            };
        } else if (shouldRender) {
            // Start fade out immediately
            setIsVisible(false);
            
            // Keep rendered during fade out transition
            const fadeOutTimer = setTimeout(() => {
                setShouldRender(false);
                document.body.style.overflow = 'unset';
            }, 300); 

            return () => {
                clearTimeout(fadeOutTimer);
                document.removeEventListener('keydown', handleEscape);
            };
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, shouldRender]);

    // Billboard click sound
    const playClickSound = () => {
        clickSoundInstance.currentTime = 0; 
        clickSoundInstance.play();
    }

    const handleClose = () => {
        playClickSound();
        onClose();
    };

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            handleClose();
        }
    };

    if (!shouldRender) return null;

    return (
        <div 
            className={`modal_overlay ${isVisible ? 'modal_fade_in' : 'modal_fade_out'}`} 
            onClick={handleOverlayClick}
        >
            <div 
                className={`modal_content ${isVisible ? 'modal_content_fade_in' : 'modal_content_fade_out'}`} 
                onClick={(e) => e.stopPropagation()}
                style={{
                    fontFamily: bebasFont
                }}
            >
                <div className="modal_header">
                    {title && <h2 className="modal_title" style={{ margin: '0 0 1rem 0', color: 'var(--main-color)' }}>{title}</h2>}
                    <div className="modal_exit_container">
                        <button className="exitButton" onClick={handleClose}></button>
                    </div>
                </div>
                <div className="modal_body">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Modal;